import { render, staticRenderFns } from "./TeamSelectionModal.vue?vue&type=template&id=2cd8154f&scoped=true"
import script from "./TeamSelectionModal.vue?vue&type=script&lang=js"
export * from "./TeamSelectionModal.vue?vue&type=script&lang=js"
import style0 from "./TeamSelectionModal.vue?vue&type=style&index=0&id=2cd8154f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd8154f",
  null
  
)

export default component.exports